<div class="container-fluid vh-100 d-flex align-items-center justify-content-center">
  <div class="row align-items-center w-100">
    <div class="col-12 col-md-8">
      <div class="login-form">
        <form [formGroup]="loginForm"  (ngSubmit)="login($event)">

          <div class="text-center width-100 mb-4">
            <img src="/assets/img/SellUp-Logo-Black.png" alt="" width="150" />
          </div>
          <div *ngIf="error" class="text-center width-100 mb-4">
            <p class="text-danger">Credenziali errate</p>
          </div>

          <div class="form-group mb-4">
            <label for="email" class="form-label">{{"SHARED.EMAIL" | translate}}</label>
            <input id="email" type="email"  class="form-control"  formControlName="email" placeholder="example@gmail.com" autocomplete="email">
          </div>
          <div class="form-group mb-4">
            <label for="password" class="form-label">{{"SHARED.PASSWORD" | translate}}</label>
            <input id="password" type="password" class="form-control" formControlName="password"  placeholder="Password"  autocomplete="current-password">
          </div>
          <div class="text-center mb-4 d-grid">
            <button type="submit" [disabled]="!loginForm.valid || loading" class="btn btn-primary">{{"LOGIN.LOGIN" | translate}}</button>
          </div>
        </form>
        <div class="text-center mb-4 d-grid gap-2">
        <!--   <button (click)="resetPwd()" class="btn btn-link">
            {{"LOGIN.FORGOT_PASSWORD" | translate}}
          </button>-->
          <a routerLink="/sign-up" class="btn btn-primary"><i class="fi fi-rr-shopping-bag mr-2"></i>{{"LOGIN.CREATE_ACCOUNT" | translate}}</a>
        </div>

      </div>


    </div>
    <div class="col-12 col-md-4 login-img p-0 d-none d-md-block">
      <div class="login-overflow"></div>
      <img src="assets/img/login-img.jpg" width="auto" class="image-fluid overflow-hidden">
    </div>
  </div>
</div>
